exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mynewsdesk-follow-button {\n  /* margin-left: 62px; */\n  margin-left: 14px;\n  max-width: 120px;\n}\n", ""]);

// exports
